import { ApiService } from "../..";

export const removeSampleLabel = (sampleId: string, data: {
  value: string
}) => {
  return ApiService.baseAction(
    `sample/remove_sample_label/${sampleId}`,
    { data },
    "delete"
  );
};
